import { PreferencesContext } from "../../contexts/PreferencesContext";
import React, { Component } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { withRouter, Redirect, Link } from 'react-router-dom';
import { logout } from '../../actions/AppActions';
import { connect } from 'react-redux';
import SweetAlert from 'react-bootstrap-sweetalert';

// unidades
import moment from 'moment';
import { URL } from '../../variables';
import ReactPaginate from 'react-paginate';
import Tooltip from 'react-tooltip';
import { MdDelete, MdModeEdit, MdSearch } from 'react-icons/md';
import { Pagination } from '@material-ui/lab';
import { CircularProgress } from '@material-ui/core';
import { FaListAlt } from 'react-icons/fa';
import Search from '../ReusableComponents/Search';
import { BsFillEyeFill } from "react-icons/bs";
import { Button } from "react-bootstrap";
import StatusBadge from "../ReusableComponents/StatusBadge";

class ModulosSistema extends Component {static contextType = PreferencesContext;

  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      path: '/',
      loading_screen: false,
      categorias: [],
      pagination: {
        page: 1,
        last_page: 1
      },
      msgErro: '',
      show_warning: false,
      show_erro: false,
      unidade_to_delete: '',
      search: '',
      loading_search: true
    };
  }






  componentDidMount() {

    this.get_categorias(this.state.pagination.page, '', false);
  }

  get_categorias(page, search = '', busca = true) {
    if (busca == true) {
      if (this.state.loading_search == false) {
        this.setState({ loading_search: true });
      }
    } else
    if (this.state.loading_screen === false) {
      this.setState({ loading_screen: true });
    }
    fetch(`${URL}api/faculdade/get_categorias?page=${page}&search=${search}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Authorization': `Bearer ${this.props.token}`
        // 'Content-Type': 'application/json',
      }
    }).then(async (responseLog) => {
      try {
        let resp = await responseLog.json();
        console.log(resp);
        if (resp.message == "Unauthenticated.") {
          localStorage.removeItem('token');localStorage.removeItem('user');
          this.props.logout();
          return;
        }
        if (resp.errors != null || resp.error != null) {
          let errors = Object.values(resp.errors);
          let erro = '';
          for (let i = 0; i < errors.length; i++) {
            if (i != errors.length - 1)
            erro += errors[i] + '\n';else

            erro += errors[i];
          }
          console.log(erro);
          this.setState({ redirect: true });
        } else
        {
          this.setState({ loading_search: false, categorias: resp.categorias, loading_screen: false, pagination: resp.pagination });
        }
      } catch (err) {
        this.setState({ redirect: true });
        console.log(err);
      }

    }).
    catch((err) => {
      this.setState({ redirect: true });

      console.log(err);
      // this.props.mudarLoadingHome(false);
    });
  }


  delete_categoria(id) {

    fetch(`${URL}api/faculdade/delete_categoria/${id}`, {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
        'Authorization': `Bearer ${this.props.token}`
        // 'Content-Type': 'application/json',
      }
    }).then(async (responseLog) => {
      try {
        let resp = await responseLog.json();
        console.log(resp);
        if (resp.message == "Unauthenticated.") {
          localStorage.removeItem('token');localStorage.removeItem('user');
          // this.setState({redirect:true,path:'/'});
          this.props.logout();
          return;
        }
        if (resp.errors != null || resp.error != null) {
          let errors = Object.values(resp.errors);
          let erro = '';
          for (let i = 0; i < errors.length; i++) {
            if (i != errors.length - 1)
            erro += errors[i] + '\n';else

            erro += errors[i];
          }
          console.log(erro);
          this.setState({ msgErro: erro, show_warning: false, show_erro: true });
        } else
        {
          this.setState({ show_warning: false });
          this.get_categorias(this.state.pagination.page, this.state.search);
        }




      } catch (err) {
        this.setState({ redirect: true });
        console.log(err);


      }

    }).
    catch((err) => {
      this.setState({ redirect: true });

      console.log(err);
    });
  }







  render() {
    console.log(this.props.user?.empresa);
    return (
      <div className="row">
                {this.state.redirect == true && <Redirect to={this.state.path} />}

                <div className="col-12">
                    <div className="card">
                        <div className="card-body" id="card">

                            <h4 className="mt-0 header-title" style={{ fontSize: '1.5rem', color: 'black' }}>{this.context.t("title_system_modules")}</h4>
                            <p style={{ fontSize: '1rem', color: 'black' }}>{this.context.t("desc_system_modules")}</p>
                            <br />
                            <br />
                            <p><b>{this.context.t("legacy_tipos_de_status")}</b></p>
                            <p style={{ color: 'green' }}>{this.context.t("desc_status_active")}</p>
                            <p style={{ color: 'darkgoldenrod' }}>{this.context.t("desc_status_maintenance")}</p>
                            <p style={{ color: 'red' }}>{this.context.t("desc_status_inactive")}</p>

                            <div className="row">

                                <div className="col-12">


                                    {/* <hr /> */}
                                    {this.state.loading_screen == false && <div>

                                        {/* <h4 className="mt-0 header-title" style={{ fontSize: '1.2rem', color: 'black', textAlign: 'center' }}>Questões</h4> */}
                                        {/* <br /> */}



                                        <div className="table-modern-card">
                                            <div className="table-modern-scroll mb-0">
                                                <table id="tech-companies-1" className="table table-striped">
                                                    <thead>
                                                        <tr>

                                                            <th>{this.context.t("label_module")}</th>
                                                            <th>{this.context.t("label_description")}</th>
                                                            {<th>{this.context.t("label_module_status")}</th>}


                                                            <th data-priority="3">{this.context.t("label_updated_at")}</th>
                                                            <th data-priority="3">{this.context.t("label_actions")}</th>

                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.loading_search == false && <>
                                                        <tr>
                                                            <td>{this.context.t("legacy_administrador")}</td>
                                                            <td>{this.context.t("legacy_modulo_administrativo_utilizado_para_fazer_todos_os_cadastros_no_siste")}</td>
                                                            <td><StatusBadge labelKey="status_active" tone="success" /></td>
                                                            <td>{'01/' + moment().format('MM/YYYY')} 03:00:00</td>
                                                            <td><a target='_blank' href="https://admin.ontest.com.br">{this.context.t("action_access")}</a></td>

                                                        </tr>
                                                        <tr>
                                                            <td>{this.context.t("legacy_corretor")}</td>
                                                            <td>{this.context.t("legacy_modulo_para_correcao_de_questoes_dissertativas_e_redacoes")}</td>
                                                            <td><StatusBadge labelKey="status_active" tone="success" /></td>
                                                            <td>{'01/' + moment().format('MM/YYYY')} 02:30:00</td>
                                                            <td><a target='_blank' href="https://corretor.ontest.com.br">{this.context.t("action_access")}</a></td>
                                                        </tr>
                                                        <tr>
                                                            <td>{this.context.t("legacy_avaliador")}</td>
                                                            <td>{this.context.t("legacy_modulo_para_aplicacao_de_prova_oral_onde_os_avaliadores_conseguem_entr")}</td>
                                                            <td><StatusBadge labelKey="status_active" tone="success" /></td>
                                                            <td>{'01/' + moment().format('MM/YYYY')} 03:00:00</td>
                                                            <td><a target='_blank' href="https://avaliador.ontest.com.br">{this.context.t("action_access")}</a></td>
                                                        </tr>
                                                        <tr>
                                                            <td>{this.context.t("legacy_elaborador")}</td>
                                                            <td>{this.context.t("legacy_modulo_para_cadastros_de_questoes_por_parte_de_professores_elaboradoes")}</td>
                                                            <td><StatusBadge labelKey="status_active" tone="success" /></td>
                                                            <td>{'01/' + moment().format('MM/YYYY')} 02:30:00</td>
                                                            <td><a target='_blank' href="https://elaborador.ontest.com.br">{this.context.t("action_access")}</a></td>
                                                        </tr>
                                                        <tr>
                                                            <td>{this.context.t("legacy_fiscal")}</td>
                                                            <td>{this.context.t("legacy_modulo_de_fiscalizacao_proctoring_do_candidato_durante_todo_o_perido_d")}</td>
                                                            <td><StatusBadge labelKey="status_active" tone="success" /></td>
                                                            <td>{'01/' + moment().format('MM/YYYY')} 03:00:00</td>
                                                            <td><a target='_blank' href="https://fiscal.ontest.com.br">{this.context.t("action_access")}</a></td>
                                                        </tr>
                                                        <tr>
                                                            <td>{this.context.t("legacy_candidato")}</td>
                                                            <td>{this.context.t("legacy_modulo_para_acesso_do_candidato")}</td>
                                                            <td><StatusBadge labelKey="status_active" tone="success" /></td>
                                                            <td>{'01/' + moment().format('MM/YYYY')} 03:00:00</td>
                                                            <td><a target='_blank' href="https://candidato.ontest.com.br">{this.context.t("action_access")}</a></td>
                                                        </tr>
                                                        </>}

                                                    </tbody>
                                                </table>

                                            </div>
                                        </div>


                                        {/* {this.state.andamento == true && <AvaliacaoAndamento get_processo={this.get_processo.bind(this)} {...this.props} />} */}

                                    </div>}

                                    {this.state.loading_screen == true && <div className="row"> <div className="col-12 d-flex justify-content-center align-items-center" style={{ marginTop: '2rem' }}>
                                        {/* <div className="spinner-border text-primary" role="status"  >
                        </div> */}
                                        <CircularProgress />
                                    </div></div>}




                                </div>

                            </div>

                        </div>

                    </div>
                </div>
            </div>);

  }


}
const mapsStateToProps = (state) => (
{
  user: state.AppReducer.user,
  token: state.AppReducer.token
});


export default connect(mapsStateToProps, { logout })(ModulosSistema);
